import React, { useEffect, useState } from "react";
import { Tab, TabKeys } from "../../data/tabs";
import styles from "./TabContainer.module.scss";

interface TabContainerProps {
  tabs: Tab[];
  selectedTab: TabKeys;
}

export const TabContainer: React.FC<TabContainerProps> = ({
  tabs,
  selectedTab,
}) => {
  const [currentTab, setCurrentTab] = useState<Tab | undefined>();

  useEffect(() => {
    const newTab = tabs.find((t) => t.key === selectedTab);
    if (newTab && newTab !== currentTab) {
      setCurrentTab(newTab);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [selectedTab, tabs]);

  if (!currentTab) return null;

  return (
    <div className={styles["tab-container"]}>
      <div className={styles["tab-content"]} key={currentTab.key}>
        {currentTab.component}
      </div>
    </div>
  );
};
